var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5262 8.93204C6.8845 8.58752 7.45424 8.59869 7.79875 8.95699L12.25 13.6823L16.7013 8.95699C17.0458 8.59869 17.6155 8.58752 17.9738 8.93204C18.3321 9.27655 18.3433 9.84629 17.9987 10.2046L12.8988 15.6046C12.7291 15.7811 12.4948 15.8808 12.25 15.8808C12.0052 15.8808 11.7709 15.7811 11.6013 15.6046L6.50125 10.2046C6.15674 9.84629 6.16791 9.27655 6.5262 8.93204Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.583a2ae1db781d41e08f0893f04bb597.svg";
export { ForwardRef as ReactComponent };